import React, { useMemo } from 'react'
import 'date-fns';
import { DropzoneArea } from 'material-ui-dropzone';
import * as wjInput from '@grapecity/wijmo.react.input';
import DateFnsUtils from '@date-io/date-fns';
import jaLocale from "date-fns/locale/ja";
import {
  MuiPickersUtilsProvider,
  DatePicker
} from '@material-ui/pickers';
import {
  Paper, Grid, Button, TextField, OutlinedInput,
  InputLabel, MenuItem, FormControl, Select, Typography,
  makeStyles, Theme, createStyles, Radio, RadioGroup, FormControlLabel,
  FormLabel, FormHelperText, CircularProgress, Checkbox, IconButton,
} from '@material-ui/core';
import AttachFileOutlinedIcon from '@material-ui/icons/AttachFile';
import { Autocomplete } from '@material-ui/lab';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { green } from '@material-ui/core/colors';
import TextMaskInput from '../../../TextMaskInput'
import { typeputForm, typeUserInfoList, typeQaContent } from '../../../../../api/helpline/qa';
import { typeUserInfo } from '../../../../../api/helpline/user';
import { typeCategory, typeMemberList } from '../../../../../api/helpline/master';
import { typeContractItemList } from '../../../../../api/helpline/keiyaku';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      width: '90%'
    },
    form: {
      margin: theme.spacing(2),
      padding: theme.spacing(1),
    },
    mWidth: {
      marginTop: theme.spacing(1),
      maxWidth: "80%",
      minWidth: "40%",
    },
    suport: {
      marginTop: theme.spacing(1),
      width: "80%",
    },
    departmentWidth: {
      marginTop: theme.spacing(1),
      width: "90%",
    },
    lWidth: {
      marginTop: theme.spacing(1),
      width: "100%",
    },
    button: {
      margin: theme.spacing(1),
    },
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    previewChip: {
      marginBottom: theme.spacing(1),
      minWidth: "80px",
      maxWidth: "250px",
    },
    attachedIcon: {
      width: '30px'
    },
    attachedremoveButton: {
      width: '25px'
    }
  }),
);

interface Prop {
  userInfoList: typeUserInfoList | undefined,
  userInfo: typeUserInfo | undefined,
  basicForm: typeputForm,
  newfile: {
    attachedFile: string;
    attachedFileData: string;
  },
  memberList: typeMemberList[] | undefined,
  contractItemList: typeContractItemList[],
  questionway: typeCategory[] | undefined,
  ss_version: typeCategory[] | undefined,
  ss_serverOS: typeCategory[] | undefined,
  ss_serverDB: typeCategory[] | undefined,
  ss_serverConnect: typeCategory[] | undefined,
  ss_applicationserver: typeCategory[] | undefined,
  ss_clientOS: typeCategory[] | undefined,
  ss_clientDB: typeCategory[] | undefined,
  qastatus: typeCategory[] | undefined,
  keiyakuClsCd: string,
  answerDate: Date | null,
  reqItem: {
    qPersonCd: boolean;
    qaTitle: boolean;
    qaSeCd: boolean;
    custmNo: boolean;
    keiyakuNo: boolean;
  },
  loginUser: boolean,
  loading: boolean,
  cisUserList: {
    userCd: string;
    userName: string;
  }[],
  fileloading: boolean,
  handleChangeSeCd: (seObj: {
    userCd: string;
    userName: string;
  }) => void
  handleChangeUserCd: (memberObj: typeMemberList) => void,
  handleChangeForm: (event: React.ChangeEvent<{
    value: unknown;
    name?: string | undefined;
  }>) => void,
  handleClickMenu: (event: React.ChangeEvent<{ id?: string | undefined; }>) => void,
  _onInitialized: (sender: any) => void,
  _onValueChanged: (sender: {
    value: Date;
  }) => void,
  handleChangeFile: (files: File[]) => Promise<void>,
  handleRemoveFile: () => string,
  fileRemoveButton: () => void,
  handleSetLoginUserCd: (event: React.ChangeEvent<HTMLInputElement>) => void,
  onSubmit: () => void,
  fileDownload: (filepath: string) => void,
  selectKeiyaku: typeContractItemList | undefined,
  qaContent: typeQaContent | undefined,
}

const MAX_FILESIZE: number = parseInt(process.env.REACT_APP_MAX_FILESIZE!, 10)
const keiyakuss = process.env.REACT_APP_KEIYAKU_APP_SS!
const keiyakuss400 = process.env.REACT_APP_KEIYAKU_APP_SS400!
const newservice = process.env.REACT_APP_KEIYAKU_NEW_SERVICE!
const webservice = process.env.REACT_APP_KEIYAKU_NEW_WEBTECHINICAL!
const appservice = process.env.REACT_APP_KEIYAKU_NEW_APP!

const QABasicEditForm: React.FC<Prop> = (props) => {
  const classes = useStyles();
  const { userInfoList, userInfo, basicForm, newfile, keiyakuClsCd, fileloading, memberList, cisUserList, loginUser, loading, answerDate, reqItem, contractItemList, questionway, qastatus, ss_version, ss_serverOS, ss_serverDB, ss_clientOS, ss_clientDB, ss_applicationserver, ss_serverConnect, handleChangeSeCd, handleChangeUserCd, handleChangeForm, handleClickMenu, _onInitialized, _onValueChanged, handleChangeFile, handleRemoveFile, fileRemoveButton, handleSetLoginUserCd, fileDownload, onSubmit, selectKeiyaku, qaContent } = props

  const check = useMemo(() => reqItem.custmNo ? true : reqItem.keiyakuNo ? true : reqItem.qPersonCd ? true : reqItem.qaTitle ? true : loginUser ? false : reqItem.qaSeCd, [reqItem, loginUser])

  const displayIncident = useMemo(() => {
    if (selectKeiyaku) {
      if (selectKeiyaku.keiyakuClsNotes === newservice || selectKeiyaku.keiyakuClsNotes === appservice) {
        return true
      } else {
        return false
      }
    } else { return false }
  }, [selectKeiyaku])

  const parsedNum = (all: any) => {
    let num = 0
    if (all) {
      num = Number(all)
      if (isNaN(num)) { num = 0 }
    }
    return num
  }

  const incidentValidCount = useMemo((): number => {
    if (qaContent && (qaContent.incidentCount || qaContent.incidentAddCount)) {
      return parsedNum(qaContent.incidentCount) + parsedNum(qaContent.incidentAddCount)
    } else { return 0 }
  }, [qaContent, selectKeiyaku])

  const incidentRemain = useMemo(() => {
    if (qaContent && (qaContent.incidentUsedCount || incidentValidCount)) {
      return incidentValidCount - parsedNum(qaContent.incidentUsedCount)
    } else { return 0 }
  }, [incidentValidCount])

  return (
    <React.Fragment>
      <form className={classes.form}>
        <Grid container direction="row" justify="center" alignItems="center">
          <Paper elevation={0} className={classes.paper}>
            <Grid container direction="row" justify="flex-start" alignItems="center">
              <Grid item xs={12} sm={6}>
                <FormControl className={classes.mWidth} margin="dense" variant="outlined">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={jaLocale}>
                    <DatePicker
                      disableToolbar
                      variant="inline"
                      inputVariant="outlined"
                      format="yyyy/MM/dd"
                      margin="none"
                      id="createDate"
                      label="問合せ日"
                      value={basicForm.qaStartSt}
                      onChange={() => { ; }}
                      disabled
                      size="small"
                      multiline
                    />
                  </MuiPickersUtilsProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl className={classes.mWidth} margin="dense" variant="outlined">
                  <TextField id="qaNo" variant="outlined" name="qaNo" value={basicForm.qaNo} label="質問番号" size="small" disabled multiline />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={7}>
                {userInfoList && (
                  <FormControl className={classes.departmentWidth} margin="dense" variant="outlined">
                    <TextField id="custmNo" variant="outlined" name="custmnNo" value={`${userInfoList.customerName} / ${userInfo && userInfo.departmentName ? userInfo.departmentName : ''}`} label="顧客名 / 組織名" size="small" disabled multiline />
                  </FormControl>
                )}
              </Grid>
              <Grid item xs={12} sm={5}>
                {memberList && memberList[0] &&
                  <FormControl className={classes.departmentWidth} variant="outlined" margin="dense" >
                    <Autocomplete
                      id="qPersonCd"
                      disableClearable={true}
                      options={memberList!}
                      defaultValue={memberList!.filter(value => value.userCd === basicForm.qPersonCd)[0]}
                      getOptionLabel={(option) => option.userName}
                      onChange={(event, value, reason) => handleChangeUserCd(value)}
                      renderInput={(params) => (
                        <TextField {...params} label="質問者名" variant="outlined" size="small" />
                      )}
                      renderOption={(option, { inputValue }) => {
                        const matches = match(((option.url ? option.url : '') + ' ' + option.userName), inputValue);
                        const parts = parse(((option.url ? option.url : '') + ' ' + option.userName), matches);
                        return (
                          <div>
                            {parts.map((part, index) => (
                              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                {part.text}
                              </span>
                            ))}
                          </div>
                        );
                      }}
                    />
                  </FormControl>
                }
              </Grid>
            </Grid>
            <React.Fragment>
              <Grid item xs={12}>
                <FormControl variant="outlined" required className={classes.mWidth} margin="dense" error={reqItem.keiyakuNo}>
                  <InputLabel id="keiyakuNo" margin="dense">契約項目</InputLabel>
                  <Select
                    labelId="keiyakuNo"
                    id="keiyakuNo"
                    name="keiyakuNo"
                    value={basicForm.keiyakuNo}
                    onChange={handleChangeForm}
                    label="契約項目"
                  >
                    {contractItemList && (contractItemList.map(value => {
                      return (
                        <MenuItem id={value.keiyakuClsCd} value={value.keiyakuNo} onClick={handleClickMenu}>{value.keiyakuClsName}</MenuItem>
                      )
                    }))}
                  </Select>
                  {reqItem.keiyakuNo && <FormHelperText>必須項目です</FormHelperText>}
                </FormControl>
              </Grid>
              {displayIncident &&
                <Grid container>
                  <Grid item>
                    <FormControl variant="outlined" required className={classes.mWidth} margin="dense">
                      <TextField id="incidentCount" name="incidentCount" label="有効インシデント" size="small" value={incidentValidCount} variant="outlined" disabled />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined" required className={classes.mWidth} margin="dense">
                      <TextField id="incidentfinished" name="incidentfinished" label="残インシデント" size="small" value={incidentRemain} variant="outlined" disabled />
                    </FormControl>
                  </Grid>
                </Grid>
              }
              <ContractItem
                handleChangeForm={handleChangeForm}
                keiyakuClsCd={keiyakuClsCd}
                basicForm={basicForm}
                ss_version={ss_version}
                ss_serverOS={ss_serverOS}
                ss_serverDB={ss_serverDB}
                ss_serverConnect={ss_serverConnect}
                ss_applicationserver={ss_applicationserver}
                ss_clientOS={ss_clientOS}
                ss_clientDB={ss_clientDB} />
              <Grid item xs={12}>
                <FormControl component="fieldset" className={classes.mWidth} variant="outlined" margin="dense">
                  <FormLabel component="legend">問合せ方法</FormLabel>
                  <RadioGroup row id="qaWayClsCd" name="qaWayClsCd" onChange={handleChangeForm} defaultValue={basicForm.qaWayClsCd}>
                    {questionway && (
                      questionway.map(value => {
                        return (
                          <FormControlLabel
                            value={value.categoryCd}
                            control={<Radio color="primary" size="small" />}
                            label={value.categoryName}
                          />
                        )
                      }))}
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <InputLabel style={{ marginTop: '6px' }}>回答希望日 (yyyy/MM/dd)</InputLabel>
                <FormControl className={classes.mWidth} margin="dense" style={{ marginTop: '4px' }} variant="outlined">
                  <wjInput.InputDate
                    initialized={_onInitialized}
                    valueChanged={_onValueChanged}
                    isRequired={false}
                    value={answerDate}
                    name="answerDate"
                  />
                  <FormHelperText id='answerDateWijmo'>希望日までの回答をお約束するものではございません</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl className={classes.lWidth} margin="dense" variant="outlined" error={reqItem.qaTitle}>
                  <TextField id="qaTitle" name="qaTitle" label="問合せタイトル" value={basicForm.qaTitle} size="small" onChange={handleChangeForm} variant="outlined" required error={reqItem.qaTitle} />
                  {reqItem.qaTitle && <FormHelperText>必須項目です</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl className={classes.lWidth} margin="dense" variant="outlined">
                  <TextField id="qaContents" name="qaContents" label="問合せ内容" multiline size="small" value={basicForm.qaContents} onChange={handleChangeForm} variant="outlined" />
                  <FormHelperText>複数行入力できます</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl className={classes.mWidth} variant="outlined" margin="dense">
                  <InputLabel htmlFor='relatedQaNo'>関連Q&A番号</InputLabel>
                  <OutlinedInput
                    value={basicForm.relatedQaNo}
                    id='relatedQaNo'
                    name='relatedQaNo'
                    label='関連Q&A番号'
                    onChange={handleChangeForm}
                    inputComponent={TextMaskInput as any}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl variant="outlined" className={classes.departmentWidth} >
                  <Typography variant="caption">添付ファイル</Typography>
                  {basicForm.attachedFile && (
                    <React.Fragment>
                      <Grid container spacing={1} direction="row" justify="flex-start" alignItems="center">
                        <Grid item>
                          <IconButton component="span" size="small" className={classes.attachedIcon} disabled={fileloading} onClick={(event: any) => fileDownload(basicForm.attachedFile!)}>
                            <AttachFileOutlinedIcon fontSize="small" />
                            {fileloading && <CircularProgress size={24} className={classes.buttonProgress} />}
                          </IconButton>
                        </Grid>
                        <Grid item>
                          <Button variant="outlined" color="secondary" className={classes.attachedremoveButton} size="small" onClick={(event) => fileRemoveButton()}>削除</Button>
                        </Grid>
                      </Grid>
                      <Grid item>
                        {newfile.attachedFile && <FormHelperText error>添付ファイルは上書きされます</FormHelperText>}
                      </Grid>
                    </React.Fragment>
                  )}
                  <DropzoneArea
                    showPreviews={true}
                    showPreviewsInDropzone={false}
                    getFileRemovedMessage={(filename: string) => handleRemoveFile()}
                    useChipsForPreview
                    filesLimit={1}
                    dropzoneText={"ファイルをここにアップロード"}
                    previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                    previewChipProps={{ classes: { root: classes.previewChip }, color: 'primary', size: 'small' }}
                    previewText=""
                    showAlerts={['error']}
                    maxFileSize={MAX_FILESIZE}
                    getDropRejectMessage={(rejectedFile: File, acceptedFiles: string[], maxFileSize: number) => (`ファイルサイズの上限は${maxFileSize / 1024 / 1024}MBです`)}
                    getFileLimitExceedMessage={(fileLimit) => (`アップロード可能ファイル数は${fileLimit}です`)}
                    onChange={handleChangeFile}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1} direction="row" justify="flex-start" alignItems="center">
                  <Grid item xs={5}>
                    {cisUserList && cisUserList[0] && //cisUserList[0]追加
                      <FormControl className={classes.lWidth} variant="outlined" margin="dense" error={loginUser ? false : reqItem.qaSeCd}>
                        <Autocomplete
                          id="qaSeCd"
                          disabled={loginUser}
                          disableClearable={true}
                          options={cisUserList}
                          defaultValue={cisUserList!.filter(value => value.userCd === basicForm.qaSeCd)[0]}
                          getOptionLabel={(option) => `${option.userCd} ${option.userName}`}
                          onChange={(event, value, reason) => handleChangeSeCd(value)}
                          renderInput={(params) => (
                            <TextField {...params} label="担当SE" variant="outlined" size="small" required error={loginUser ? false : reqItem.qaSeCd} />
                          )}
                          renderOption={(option, { inputValue }) => {
                            const matches = match(`${option.userCd} ${option.userName}`, inputValue);
                            const parts = parse(`${option.userCd} ${option.userName}`, matches);
                            return (
                              <div>
                                {parts.map((part, index) => (
                                  <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                    {part.text}
                                  </span>
                                ))}
                              </div>
                            );
                          }}
                        />
                        {loginUser ? false : reqItem.qaSeCd && <FormHelperText>必須項目です</FormHelperText>}
                      </FormControl>
                    }
                  </Grid>
                  <Grid item>
                    <FormControlLabel control={<Checkbox checked={loginUser} color="primary" onChange={handleSetLoginUserCd} name="loginUser" size="small" />} label="ログインユーザー" />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {qastatus && qastatus.length !== 0 &&
                  <FormControl component="fieldset" className={classes.mWidth} variant="outlined" margin="dense">
                    <FormLabel component="legend">ステータス</FormLabel>
                    <RadioGroup row id="qaStatusClsCd" name="qaStatusClsCd" onChange={handleChangeForm} defaultValue={basicForm.qaStatusClsCd}>
                      {qastatus.map(value => {
                        return (
                          <FormControlLabel
                            value={value.categoryCd}
                            control={<Radio color="primary" size="small" />}
                            label={value.categoryName}
                          />
                        )
                      })}
                    </RadioGroup>
                  </FormControl>
                }
              </Grid>
              <Grid item xs={12}>
                <Grid container direction="column" justify="center" alignItems="center">
                  <Grid item>
                    {check && !loading && <Typography color='error' variant="caption">{`未入力の必須項目があります`}</Typography>}
                  </Grid>
                  <Grid item>
                    <div className={classes.wrapper}>
                      <Button variant="contained" color="primary" size="large"
                        className={classes.button}
                        disabled={check ? true : loading}
                        onClick={onSubmit}>
                        更新
                          </Button>
                      {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </React.Fragment>
          </Paper>
        </Grid>
      </form>
    </React.Fragment >
  )
}

interface Props {
  handleChangeForm: (event: React.ChangeEvent<{
    value: unknown;
    name?: string | undefined;
  }>) => void
  keiyakuClsCd: string | undefined,
  basicForm: typeputForm,
  ss_version: typeCategory[] | undefined,
  ss_serverOS: typeCategory[] | undefined,
  ss_serverDB: typeCategory[] | undefined,
  ss_serverConnect: typeCategory[] | undefined,
  ss_applicationserver: typeCategory[] | undefined,
  ss_clientOS: typeCategory[] | undefined,
  ss_clientDB: typeCategory[] | undefined,
}

const ContractItem: React.FC<Props> = (props) => {
  const classes = useStyles();
  const { handleChangeForm,
    keiyakuClsCd,
    basicForm,
    ss_version,
    ss_serverOS,
    ss_serverDB,
    ss_serverConnect,
    ss_applicationserver,
    ss_clientOS,
    ss_clientDB, } = props

  if (keiyakuClsCd === keiyakuss400 || keiyakuClsCd === keiyakuss) {
    return (
      <React.Fragment>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <FormControl variant="outlined" className={classes.suport} margin="dense">
              <InputLabel id="ssVersionClsCd">SuperStreamバージョン</InputLabel>
              <Select
                labelId="ssVersionClsCd"
                id="ssVersionClsCd"
                name="ssVersionClsCd"
                value={basicForm.ssVersionClsCd}
                onChange={handleChangeForm}
                label="SuperStreamバージョン"
              >
                <MenuItem value={''}>{'　'}</MenuItem>
                {ss_version && (
                  ss_version.map(value => {
                    return (
                      <MenuItem value={value.categoryCd}>{value.categoryName}</MenuItem>
                    )
                  })
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl variant="outlined" className={classes.suport} margin="dense">
              <InputLabel id="serverOsClsCd">サーバー環境(OS)</InputLabel>
              <Select
                labelId="serverOsClsCd"
                id="serverOsClsCd"
                name="serverOsClsCd"
                label="サーバー環境(OS)"
                value={basicForm.serverOsClsCd}
                onChange={handleChangeForm}
              >
                <MenuItem value={''}>{'　'}</MenuItem>
                {ss_serverOS && (
                  ss_serverOS.map(value => {
                    return (
                      <MenuItem value={value.categoryCd}>{value.categoryName}</MenuItem>
                    )
                  })
                )}
              </Select>
            </FormControl>
          </Grid>
          {keiyakuClsCd === keiyakuss && (
            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" margin="dense" className={classes.suport}>
                <InputLabel id="serverDbClsCd">サーバー環境(DB)</InputLabel>
                <Select
                  labelId="serverDbClsCd"
                  id="serverDbClsCd"
                  name="serverDbClsCd"
                  label="サーバー環境(DB)"
                  value={basicForm.serverDbClsCd}
                  onChange={handleChangeForm}
                >
                  <MenuItem value={''}>{'　'}</MenuItem>
                  {ss_serverDB && (ss_serverDB.map(value => {
                    return (
                      <MenuItem value={value.categoryCd}>{value.categoryName}</MenuItem>
                    )
                  })
                  )}
                </Select>
              </FormControl>
            </Grid>
          )}
          {keiyakuClsCd === keiyakuss400 && (
            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" margin="dense" className={classes.suport}>
                <InputLabel id="serverConnectClsCd">サーバー環境(接続)</InputLabel>
                <Select
                  labelId="serverConnectClsCd"
                  id="serverConnectClsCd"
                  name="serverConnectClsCd"
                  label="サーバー環境(接続)"
                  value={basicForm.serverConnectClsCd}
                  onChange={handleChangeForm}
                >
                  <MenuItem value={''}>{'　'}</MenuItem>
                  {ss_serverConnect && (
                    ss_serverConnect.map(value => {
                      return (
                        <MenuItem value={value.categoryCd}>{value.categoryName}</MenuItem>
                      )
                    })
                  )}
                </Select>
              </FormControl>
            </Grid>
          )}
          {keiyakuClsCd === keiyakuss && (
            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" margin="dense" className={classes.suport}>
                <InputLabel id="serverAsClsCd">アプリケーションサーバー</InputLabel>
                <Select
                  labelId="serverAsClsCd"
                  id="serverAsClsCd"
                  name="serverAsClsCd"
                  label="アプリケーションサーバー"
                  value={basicForm.serverAsClsCd}
                  onChange={handleChangeForm}
                >
                  <MenuItem value={''}>{'　'}</MenuItem>
                  {ss_applicationserver && (
                    ss_applicationserver.map(value => {
                      return (
                        <MenuItem value={value.categoryCd}>{value.categoryName}</MenuItem>
                      )
                    })
                  )}
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12} sm={6}>
            <FormControl variant="outlined" margin="dense" className={classes.suport}>
              <InputLabel id="clientOsClsCd">クライアント環境(OS)</InputLabel>
              <Select
                labelId="clientOsClsCd"
                id="clientOsClsCd"
                name="clientOsClsCd"
                label="クライアント環境(OS)"
                value={basicForm.clientOsClsCd}
                onChange={handleChangeForm}
              >
                <MenuItem value={''}>{'　'}</MenuItem>
                {ss_clientOS && (
                  ss_clientOS.map(value => {
                    return (
                      <MenuItem value={value.categoryCd}>{value.categoryName}</MenuItem>
                    )
                  })
                )}
              </Select>
            </FormControl>
          </Grid>
          {keiyakuClsCd === keiyakuss && (
            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" margin="dense" className={classes.suport}>
                <InputLabel id="clientDbClsCd">クライアント環境(DB)</InputLabel>
                <Select
                  labelId="clientDbClsCd"
                  id="clientDbClsCd"
                  name="clientDbClsCd"
                  label="クライアント環境(DB)"
                  value={basicForm.clientDbClsCd}
                  onChange={handleChangeForm}
                >
                  <MenuItem value={''}>{'　'}</MenuItem>
                  {ss_clientDB && (
                    ss_clientDB.map(value => {
                      return (
                        <MenuItem value={value.categoryCd}>{value.categoryName}</MenuItem>
                      )
                    })
                  )}
                </Select>
              </FormControl>
            </Grid>
          )}
        </Grid>
      </React.Fragment>
    )
  } else {
    return <React.Fragment></React.Fragment>
  }
}

export default QABasicEditForm
